export default {
      id: "facebook-usage",
      viewBox: "0 0 7 16",
      url: __webpack_public_path__ + "icons-sprite.f57ad8e.svg#facebook-usage",
      toString: function () {
        return this.url;
      }
    }